import { PresentBigWinActionHandler, SpinBoundaryEndActionHandler, SpinBoundaryStartActionHandler, type ReplayPlugin } from "@slot/client-engine";
import type { CaptainReactions } from "../views/character/CaptainView";

/**
 * The captain's reactions to the round (the user, 2026-10-23): he dances as the big-win panel opens, and cheers as a
 * winning spin settles without one, so a big win plays his dance alone. A spin's big win comes at its end, after its
 * wins, so the cheer waits for the spin's end too: no spin shows him a cheer and then a dance. Every spin counts, the
 * free spins' included. First in the plugin list, so each reaction starts with its action rather than after the
 * shell's presentation of it (the panel's whole count-up).
 */
export function createCaptainPlugin(captain: CaptainReactions): ReplayPlugin {
  let bigWinInSpin = false;
  return {
    name: "captain",
    actionHandlers: [
      new SpinBoundaryStartActionHandler(async () => {
        bigWinInSpin = false;
      }),
      new PresentBigWinActionHandler(async () => {
        bigWinInSpin = true;
        captain.bigWin();
      }),
      new SpinBoundaryEndActionHandler(async (input) => {
        if (!bigWinInSpin && input.spinWinAmount !== undefined && BigInt(input.spinWinAmount) > 0n) captain.win();
      }),
    ],
  };
}
